import { render } from "./UserProfileCardEditor.vue?vue&type=template&id=300c1489"
import script from "./UserProfileCardEditor.vue?vue&type=script&lang=js"
export * from "./UserProfileCardEditor.vue?vue&type=script&lang=js"
script.render = render

export default script